import { BAspect } from './aspect';
import { pluginFactory } from '../../utils/plugins';
var AspectPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BAspect: BAspect
  }
});
export { AspectPlugin, BAspect };


// WEBPACK FOOTER //
// ./node_modules/bootstrap-vue/esm/components/aspect/index.js